import he from 'he';
import { ReactNode } from 'react';

import { Markdown } from '../../lib/components/markdown/Markdown';

interface ProductCardDescriptionProps {
	className?: string;
	children?: string;
}

export const ProductCardDescription = ({ className, children }: ProductCardDescriptionProps) => {
	return (
		<Markdown
			options={{
				wrapper: 'div',
				forceWrapper: true,
				overrides: {
					img: {
						component: (): ReactNode => null,
					},
					video: {
						component: (): ReactNode => null,
					},
					ul: {
						component: ({ children }: { children: ReactNode }) => (
							<ul className="list-inside pl-0!">{children}</ul>
						),
					},
					ol: {
						component: ({ children }: { children: ReactNode }) => (
							<ol className="list-inside pl-0!">{children}</ol>
						),
					},
					// commented because of MKT-2962
					// li: {
					//     component: ({ children }) => (
					//         <li className="*:inline-block!">{children}</li>
					//     ),
					// },
				},
			}}
			className={className}
		>
			{he.decode(children || '')}
		</Markdown>
	);
};
